/* Ygeia header — mega-menu hover intent.
   Pure CSS can't hold a dropdown open across the tall floating header's gap
   between the nav row and the panel, so the open state is driven here:
     • a panel stays open while the pointer (or focus) is anywhere in the header
       — nav row, the empty gap, or the panel, which are all one DOM element;
     • entering another top-level item switches to (or closes) it;
     • it closes a beat after the pointer leaves the header entirely.
   Adds `.is-open` to the active .ygeia-header__mega and `.has-mega-open` to the
   header (the light-sheet state). Without JS the triggers stay plain links. */
(function () {
  function initHeader(header) {
    if (header.dataset.megaInit) return;
    header.dataset.megaInit = '1';

    var nav = header.querySelector('.ygeia-header__nav');
    if (!nav) return;
    var megas = Array.prototype.slice.call(nav.querySelectorAll('.ygeia-header__mega'));
    if (!megas.length) return;

    var closeTimer = null;
    function clearClose() {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    }
    function open(target) {
      clearClose();
      megas.forEach(function (m) { m.classList.toggle('is-open', m === target); });
      header.classList.toggle('has-mega-open', Boolean(target));
    }
    function scheduleClose() {
      clearClose();
      closeTimer = setTimeout(function () { open(null); }, 120);
    }

    // Entering a top-level item opens its mega — or closes the menu if that item
    // isn't a mega (a plain link or the "More" disclosure).
    Array.prototype.slice.call(nav.children).forEach(function (item) {
      var mega = item.classList.contains('ygeia-header__mega') ? item : null;
      item.addEventListener('mouseenter', function () { open(mega); });
      item.addEventListener('focusin', function () { open(mega); });
    });

    // The header (incl. the panel, a descendant) is one keep-open region.
    header.addEventListener('mouseenter', clearClose);
    header.addEventListener('mouseleave', scheduleClose);

    // Keyboard: close when focus leaves the header, or on Escape.
    header.addEventListener('focusout', function (e) {
      if (!header.contains(e.relatedTarget)) open(null);
    });
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') open(null);
    });
  }

  function init() {
    Array.prototype.slice.call(document.querySelectorAll('.ygeia-header')).forEach(initHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Theme editor re-renders the section without a full reload.
  document.addEventListener('shopify:section:load', init);
})();
